import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
import { validateUpperCase, validateLowerCase, validateDigit, validateNonAlphanumeric } from '@/utils/validate';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'ExternalApiUser',
    returnTo: 'ExternalApiUsers'
  }),
  created() {
    this.$store.dispatch('domain/getItems');
    this.$store.dispatch('workshop/getItems');
    this.$store.dispatch('getPasswordPolicy');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    passwordCompliesWithPolicy(value) {
      const passwordPolicy = this.$store.state.authentication.passwordPolicy;
      return {
        alphanumeric: !passwordPolicy.requireNonAlphanumeric || validateNonAlphanumeric(value),
        digit: !passwordPolicy.requireDigit || validateDigit(value),
        isFromDatabase: passwordPolicy.isFromDatabase,
        length: value.length >= passwordPolicy.minimumLength,
        lowercase: !passwordPolicy.requireLowercase || validateLowerCase(value),
        uppercase: !passwordPolicy.requireUppercase || validateUpperCase(value)
      };
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
